import React from 'react'
import '../styles/index.scss'
import NextBoxDiaryDetailsPage from './NextBoxDiaryDetailsPage'

function NextBoxDiaryDetailsContainer(props) {
    const { id } = props.match.params
    return (
        <div className='NextBoxDiaryDetailsContainer'>
            <NextBoxDiaryDetailsPage id={id} />
        </div>
    )
}

export default NextBoxDiaryDetailsContainer